export const fa = {
  // Navigation
  nav: {
    home: "خانه",
    ourServices: "خدمات ما",
    aboutUs: "درباره ما",
    ourTeam: "تیم ما",
    contactUs: "تماس با ما"
  },

  // Hero Section
  hero: {
    title: "با اطمینان در سطح جهانی گسترش دهید",
    subtitle: "ما از شما در راه‌اندازی کسب‌وکارتان در امارات متحده عربی، عربستان سعودی و روسیه حمایت می‌کنیم.",
    consultationTitle: "اکنون مشاوره رایگان رزرو کنید",
    startNow: "شروع کنید",
    modalTitle: "مشاوره رایگان رزرو کنید",
    countrySelect: "کشور خود را انتخاب کنید",
    countryPlaceholder: "کشوری را انتخاب کنید",
    personalInfo: "اطلاعات شخصی",
    firstName: "نام",
    lastName: "نام خانوادگی",
    emailAddress: "آدرس ایمیل",
    nationality: "ملیت",
    phoneNumber: "شماره تلفن",
    servicesLabel: "خدماتی که می‌خواهید",
    serviceSelect: "خدمت را انتخاب کنید",
    service1: "افتتاح حساب‌های بانکی",
    service2: "خدمات ویزا و مهاجرت",
    service3: "رزرو هتل",
    service4: "بلیط هواپیما",
    service5: "توسعه وب‌سایت",
    service6: "توسعه اپلیکیشن موبایل",
    submit: "ارسال"
  },

  // About Us Section
  aboutUs: {
    title: "درباره ما",
    paragraph1: "خدمات تجاری اتقان در امارات متحده عربی تأسیس شد تا به کارآفرینان و شرکت‌ها در راه‌اندازی آسان و سریع شرکت‌هایشان کمک کند. ما طیف کاملی از خدمات شامل تشکیل شرکت در سرزمین اصلی و مناطق آزاد، خدمات پرو و دولتی، مشاوره مالیاتی و مالیات بر ارزش افزوده، صورت‌های مالی و تأیید اسناد را ارائه می‌دهیم.",
    paragraph2: "در طول سال‌ها، ما به شریک قابل اعتمادی برای کارآفرینان و شرکت‌های کوچک و متوسط تبدیل شده‌ایم و راه‌حل‌های حقوقی، مالی و نظارتی بی‌نقصی ارائه می‌دهیم که رشد در امارات متحده عربی و فراتر از آن را پشتیبانی می‌کند. مأموریت ما روشن است: راه‌اندازی و عملیات کسب‌وکار را ساده، سریع و قابل اعتماد کنیم — تا بتوانید روی دستیابی به موفقیت تمرکز کنید."
  },

  // Services Section
  services: {
    title: "خدمات ما",
    subtitle: "ما راه‌حل‌های تجاری جامع ارائه می‌دهیم",
    startingFrom: "شروع از",
    mainlandCompany: {
      name: "تشکیل شرکت در سرزمین اصلی",
      desc: "شرکت خود را در سرزمین اصلی به راحتی راه‌اندازی کنید. ما تمام مراحل قانونی را مدیریت می‌کنیم تا بتوانید روی رشد کسب‌وکارتان تمرکز کنید.",
      price: "10,000 درهم"
    },
    freeZoneCompany: {
      name: "تشکیل شرکت در منطقه آزاد",
      desc: "کسب‌وکار منطقه آزاد خود را به سرعت و با هزینه کم راه‌اندازی کنید. از مالکیت انعطاف‌پذیر و راه‌اندازی ساده لذت ببرید.",
      price: "6,000 درهم"
    },
    proServices: {
      name: "خدمات پرو و دولتی",
      desc: "از تمدید مجوز تا ویزای طلایی، ما تمام تراکنش‌های دولتی شما را به راحتی مدیریت می‌کنیم."
    },
    taxConsultancy: {
      name: "مشاوره مالیاتی و مالیات بر ارزش افزوده",
      desc: "با راهنمایی متخصصان مالیاتی و مالیات بر ارزش افزوده مطابق باشید. ما به شما کمک می‌کنیم تا ریسک‌ها را به حداقل برسانید و کارایی را به حداکثر برسانید."
    },
    financialStatements: {
      name: "صورت‌های مالی",
      desc: "گزارش‌های مالی دقیق که کسب‌وکار شما را در مسیر درست نگه می‌دارند. ما شفافیت و انطباق را تضمین می‌کنیم."
    },
    documentAttestation: {
      name: "تصدیق اسناد",
      desc: "خدمات تصدیق اسناد سریع و قابل اعتماد برای تمام نیازهای تجاری شما."
    },
    bankAccounts: {
      name: "افتتاح حساب‌های بانکی",
      desc: "کمک حرفه‌ای در افتتاح حساب‌های بانکی برای افراد و شرکت‌ها در امارات متحده عربی و بین‌المللی."
    },
    visaServices: {
      name: "خدمات ویزا و مهاجرت",
      desc: "خدمات جامع ویزا و مهاجرت شامل ویزای توریستی، ویزای تجاری و مجوزهای اقامت."
    },
    hotelBooking: {
      name: "رزرو هتل",
      desc: "خدمات رزرو هتل راحت برای سفرهای تجاری و تفریحی با نرخ‌های رقابتی."
    },
    flightTickets: {
      name: "بلیط هواپیما",
      desc: "خدمات رزرو پرواز قابل اعتماد با دسترسی به بهترین معاملات و مسیرهای جهانی."
    },
    websiteDevelopment: {
      name: "توسعه وب‌سایت",
      desc: "خدمات توسعه وب‌سایت سفارشی برای ایجاد حضور آنلاین شما و رشد کسب‌وکارتان.",
      price: "1,500 درهم"
    },
    mobileAppDevelopment: {
      name: "توسعه اپلیکیشن موبایل",
      desc: "توسعه حرفه‌ای اپلیکیشن‌های موبایل برای پلتفرم‌های iOS و Android.",
      price: "3,500 درهم"
    }
  },

  // Our Team Section
  ourTeam: {
    title: "تیم ما",
    subtitle: "با متخصصان خبره ما آشنا شوید",
    members: [
      {
        name: "مهندس/هناء",
        role: "رهبر تیم راه‌اندازی کسب‌وکار"
      },
      {
        name: "مهندس/علی",
        role: "رهبر تیم راه‌اندازی کسب‌وکار"
      },
      {
        name: "مهندس/عبدالله",
        role: "رهبر تیم راه‌اندازی کسب‌وکار"
      },
      {
        name: "مهندس/سارا",
        role: "رهبر تیم راه‌اندازی کسب‌وکار"
      }
    ]
  },

  // Reviews Section
  reviews: {
    title: "مشتریان ما چه می‌گویند",
    subtitle: "نظرات مشتریان راضی",
    testimonials: [
      {
        name: "جان دو",
        role: "مدیرعامل، شرکت تیک استارت",
        text: "اتقان راه‌اندازی شرکت من در دبی را بسیار ساده و سریع کرد. تیم آنها همه چیز را به صورت حرفه‌ای مدیریت کرد و من توانستم کسب‌وکارم را بدون استرس شروع کنم. راه‌اندازی منطقه آزاد در فقط 3 روز تکمیل شد!"
      },
      {
        name: "سمیر اسمیت",
        role: "مدیر بازاریابی، راه‌حل‌های جهانی",
        text: "به لطف مشاوره مالیاتی آنها، اکنون اطمینان کامل دارم که کسب‌وکارم مطابق با قوانین و از نظر مالی امن است. تخصص آنها هزاران جریمه احتمالی را برایم صرفه‌جویی کرد."
      },
      {
        name: "مایکل براون",
        role: "صاحب کسب‌وکار، زنجیره خرده‌فروشی",
        text: "تیم خدمات پرو در اتقان فوق‌العاده است. آنها تمام تراکنش‌های دولتی من را به راحتی مدیریت کردند، از تمدید مجوزها تا درخواست ویزا. به شدت توصیه می‌کنم!"
      },
      {
        name: "امیر ویلسون",
        role: "فریلنسر، آژانس دیجیتال",
        text: "به عنوان فریلنسر، به کمک در تصدیق اسناد و افتتاح حساب بانکی نیاز داشتم. اتقان همه چیز را آسان و مقرون‌به‌صرفه کرد. حالا می‌توانم روی مشتریانم تمرکز کنم در حالی که آنها کارهای اداری را انجام می‌دهند."
      },
      {
        name: "دیوید لی",
        role: "کارآفرین، تجارت الکترونیک",
        text: "خدمات صورت‌های مالی آنها عالی است. گزارش‌ها دقیق و مفصل هستند و به من کمک کردند تا برای گسترش کسب‌وکارم تامین مالی دریافت کنم. خدمات حرفه‌ای در تمام مدت!"
      }
    ]
  },

  // Partners Section
  partners: {
    title: "شرکای ما",
    subtitle: "مورد اعتماد سازمان‌های پیشرو"
  },

  // Contact Us Section
  contactUs: {
    title: "تماس با ما",
    subtitle: "با ما در تماس باشید",
    getInTouch: "تماس بگیرید",
    contactInfo: "اطلاعات تماس",
    sendMessage: "ارسال پیام",
    name: "نام",
    email: "ایمیل",
    subject: "موضوع",
    message: "پیام",
    fullName: "نام کامل",
    fullNamePlaceholder: "نام خود را وارد کنید",
    emailAddress: "آدرس ایمیل",
    emailPlaceholder: "ایمیل خود را وارد کنید",
    phoneNumber: "شماره تلفن",
    phonePlaceholder: "شماره تلفن",
    activity: "فعالیت",
    activityPlaceholder: "فعالیت خود را وارد کنید",
    submit: "ارسال"
  },

  // Footer
  footer: {
    allRightsReserved: "تمام حقوق محفوظ است",
    privacyPolicy: "سیاست حفظ حریم خصوصی",
    termsOfService: "شرایط خدمات",
    description: "خدمات تجاری اتقان – راه‌اندازی کسب‌وکار را آسان و سریع می‌کنیم.",
    location: "موقعیت: دبی، امارات متحده عربی",
    phone: "📞 تلفن: +971 XXX XXX XXX",
    email: "✉️ ایمیل: info@itqan.com",
    copyright: "© 2025 خدمات تجاری اتقان. تمام حقوق محفوظ است.",
    companyProfile: "پروفایل شرکت"
  },

  // Ad Section
  ad: {
    title: "با اطمینان در سطح جهانی گسترش دهید",
    startNow: "شروع کنید"
  },

  // Statistics Section
  statistics: {
    title: "دستاوردهای ما",
    subtitle: "اعدادی که از موفقیت ما سخن می‌گویند",
    clients: "مشتریان خوشحال",
    experience: "سال تجربه",
    partners: "شرکای قابل اعتماد"
  }
}; 